import { render, staticRenderFns } from "./Cms.vue?vue&type=template&id=e22389ee"
import script from "./Cms.vue?vue&type=script&lang=js"
export * from "./Cms.vue?vue&type=script&lang=js"
import style0 from "./Cms.vue?vue&type=style&index=0&id=e22389ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports